import { useTranslation } from 'react-i18next';
import { AlertCircle, CheckCircle2, Loader2 } from 'lucide-react';
import {
  AssistantUploadStatus,
  type AssistantUploadStatus as UploadStatus,
} from '@xtreed/academy-shared';
import { cn } from '@/lib/utils';

interface UploadStatusBadgeProps {
  status: UploadStatus;
  progress?: number | null;
  className?: string;
}

export function UploadStatusBadge({
  status,
  progress,
  className,
}: UploadStatusBadgeProps) {
  const { t } = useTranslation('adminAssistant');
  const ready = status === AssistantUploadStatus.READY;
  const failed = status === AssistantUploadStatus.FAILED;
  const uploading =
    status === AssistantUploadStatus.UPLOADING &&
    progress !== null &&
    progress !== undefined;

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 text-[11px] font-medium',
        ready && 'text-primary-ink',
        failed && 'text-destructive',
        !ready && !failed && 'text-muted-foreground',
        className,
      )}
    >
      {ready ? (
        <CheckCircle2 className="h-3 w-3" />
      ) : failed ? (
        <AlertCircle className="h-3 w-3" />
      ) : (
        <Loader2 className="h-3 w-3 animate-spin" />
      )}
      {uploading
        ? `${Math.round((progress as number) * 100)}%`
        : t(`uploads.status.${status}`)}
    </span>
  );
}
